import useFetchData from 'app/hooks/useFetchData';
import { getListParkApi } from 'app/services/homeApi';
import { useMemo } from 'react';

const PARK_LISTING_PAYLOAD = {
  limit: 50,
  page: 1,
  checkPermission: true,
  inactive: 1,
};
const PARK_CACHE_DURATION = 5 * 60 * 1000;

export const useParkNameMap = () => {
  const { result, isLoading } = useFetchData<any>({
    actionApi: getListParkApi,
    payloadData: PARK_LISTING_PAYLOAD,
    cacheDurationMs: PARK_CACHE_DURATION,
  });

  const parkById = useMemo(() => {
    const parks: any[] = result?.data ?? [];
    return parks.reduce(
      (acc: Record<string, { name: string; shortName: string }>, park) => {
        acc[String(park?.id)] = {
          name: park?.name ?? '',
          shortName: park?.workstationId ?? '',
        };
        return acc;
      },
      {},
    );
  }, [result]);

  return { parkById, isLoadingPark: isLoading };
};

export default useParkNameMap;
